import { Avatar } from 'antd'
import { FC } from 'react'
import { BitazzaText } from '../../../../components'
import { getAvatarImage } from '../../../../util/getAvatar'
import Styles from './Badges.module.scss'

interface Props {
    type: string
    name?: string
    rank?: number | string
    highlighted?: boolean
    bolderAvatar?: boolean
    big?: boolean
    userRank?: boolean
    table?: boolean
    color?: string
    onClick?: () => void
    seasonSummery?: boolean
    noAvatar?: boolean
    label?: string
    top3?: boolean
    bigAvatar?: boolean
    isDesktop?: boolean
}

export const Badges: FC<Props> = ({
    type,
    name,
    rank,
    highlighted,
    bolderAvatar,
    big,
    userRank,
    table,
    color,
    onClick,
    seasonSummery,
    noAvatar,
    label,
    top3,
    bigAvatar,
    isDesktop,
}) => {
    const getStyle = () => {
        if (bigAvatar) {
            if (isDesktop) {
                if (highlighted) {
                    return { width: '108px', height: '108px' }
                } else {
                    return { width: '72px', height: '72px' }
                }
            } else {
                if (highlighted) {
                    return { width: '64px', height: '64px' }
                } else {
                    return { width: '40px', height: '40px' }
                }
            }
        } else {
            return { width: '40px', height: '40px' }
        }
    }

    return (
        <div className={Styles.container} onClick={onClick}>
            {!noAvatar ? (
                <Avatar
                    shape="square"
                    style={getStyle()}
                    size={
                        table
                            ? 42
                            : seasonSummery
                            ? 148
                            : userRank
                            ? 58
                            : big && highlighted
                            ? 104
                            : big
                            ? 100
                            : bolderAvatar
                            ? 82
                            : highlighted
                            ? 76
                            : 66
                    }
                    icon={
                        <img
                            src={getAvatarImage(type)}
                            alt="avatar"
                            style={{ position: 'relative', zIndex: 0 }}
                        />
                    }
                />
            ) : null}
            {name && rank ? (
                <div className={Styles.wrapper}>
                    <BitazzaText
                        content={name}
                        color={isDesktop ? '#FFFFFF' : '#D2D2D2'}
                        format={isDesktop ? 't24' : highlighted ? 't14' : 't10'}
                        bold
                        noWrap
                    />
                    <BitazzaText
                        strong
                        content={rank}
                        format={isDesktop ? 't16' : highlighted ? 't14' : 't10'}
                        color={color}
                        bold
                        noWrap
                    />
                </div>
            ) : null}
        </div>
    )
}
